import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import LinkFormFonts from './LinkFormFont'
import LinkFormStyle from './LinkFormStyle'
import type { LinkFormBrandType, LinkBrandForms } from './linkTypes'

const FORM_MAP: LinkBrandForms = {
  [BrandFormEnum.STYLE]: LinkFormStyle,
  ...LinkFormFonts,
}

const LinkFormBrand: LinkFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(LinkFormBrand) as typeof LinkFormBrand
